import { render } from "./AnagraficaFarmacieAssegnate.vue?vue&type=template&id=dd778196"
import script from "./AnagraficaFarmacieAssegnate.vue?vue&type=script&lang=js"
export * from "./AnagraficaFarmacieAssegnate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__